export default __webpack_public_path__ + "static/Ogg-MediumItalic-a7ca72c9940745e4cf971d47ded0449d.ttf";